// import { Injectable } from '@angular/core';
// import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
// import { Observable } from 'rxjs';
// import { RestserviceService } from './restservice.service';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuard {
//   canActivate: CanActivateFn = (
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

//     const token = localStorage.getItem('token');
//     if (!token || this.isTokenExpired(token)) {
//       this.handleLogout();
//       return this.router.createUrlTree(['/login']);
//     }

//     const isAuthenticated = this.authService.isAuthenticated();
//     if (!isAuthenticated) {
//       this.router.navigate(['/login']);
//     }

//     return true;
//   }

//   private isTokenExpired(token: string): boolean {
//     try {
//       const payload = JSON.parse(atob(token.split('.')[1]));
//       const expirationDate = payload.exp * 1000;
//       return expirationDate < Date.now();
//     } catch (e) {
//       return true;
//     }
//   }

//   private handleLogout(): void {
//     localStorage.clear();
//     sessionStorage.clear();
//     this.router.navigate(['/login']);
//   }

//   constructor(
//     private authService: RestserviceService,
//     private router: Router
//   ) {}
// }
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { clearSession } from '../_auth/session';
import { readToken } from '../_auth/token-store';
import { RestserviceService } from './restservice.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  canActivate: CanActivateFn = (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree => {
    // Check if a valid token is available
    const token = readToken();
    if (!token || this.isTokenExpired(token)) {
      // If no token or token is expired, log out the user and redirect to login
      this.handleLogout();
      return this.router.createUrlTree(['/login']);
    }

    // If the token is valid, check if the user is authenticated using the auth service
    const isAuthenticated = this.authService.isAuthenticated();
    if (!isAuthenticated) {
      // If not authenticated, navigate to login page
      this.router.navigate(['/login']);
      return false; // Prevent navigation to protected route
    }

    // If token is valid and the user is authenticated, allow access to the route
    return true;
  };

  private isTokenExpired(token: string): boolean {
    try {
      // Decode the token and check the expiration time
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expirationDate = payload.exp * 1000; // Convert expiration to milliseconds
      return expirationDate < Date.now(); // If expired, return true
    } catch (e) {
      // If there's an error in decoding, treat the token as expired
      return true;
    }
  }

  private handleLogout(): void {
    // Enumerated clear rather than localStorage.clear(), so unrelated
    // preferences (theme, language) survive an expired session.
    clearSession();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  constructor(
    private authService: RestserviceService, // Auth service for user authentication status
    private router: Router, // Router for navigation and redirection
  ) {}
}
